import React, { useEffect } from 'react';

import { BrokerPricing } from 'src/components';

import classes from './pricing.module.scss';

export const Pricing = (props) => {
  const { isAgency = false } = props;

  useEffect(() => {
    document.title = 'Monark | Pricing';
  }, []);

  return (
    <div className={classes.Layout}>
      <div className={classes.LayoutEllipseLeft} />
      <div className={classes.LayoutEllipseRight} />
      <div className={classes.LayoutLightLine} />
      <div className={classes.Pricing} style={{ paddingTop: !isAgency ? 60 : 0 }}>
        <div className={classes.PricingContent}>
          <BrokerPricing isAgency={isAgency} />
        </div>
      </div>
    </div>
  );
};
